import styled from 'styled-components';

export const RejectRecommendationContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  padding: ${({ theme: { token } }) => `${token.paddingMD}px`};
  flex-direction: column;
  gap: 1rem;

  .comments-container {
    gap: 0.5rem;

    .ant-input {
      width: 100%;
    }
  }

  .error {
    border-color: ${({ theme: { token } }) => token.colorError};
  }

  .error-message {
    color: ${({ theme: { token } }) => token.colorError};
    font-size: ${({ theme: { token } }) => token.fontSize};
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    display: flex;
  }

  .table-selector {
    display: flex;
    align-items: center;
    gap: 4rem;
  }

  .table-selector .label {
    font-weight: 500;
    font-size: ${({ theme }) => theme.token.fontSizeSM}px;
    white-space: nowrap;
    margin-right: 0.5rem;
  }

  .table-dropdown {
    flex: 1;
    min-width: 15.625rem;
  }
`;

export const RejectReasonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;

  p {
    width: 7em;
    margin: 0;
    font-size: ${({ theme }) => theme.token.fontSizeSM}px;
    line-height: 1.4;
    word-break: break-word;
    white-space: normal;
  }

  .ant-select {
    flex: 1;
    min-width: 0;
    max-width: 100%;
    .ant-select-selection-placeholder {
      white-space: normal !important;
      text-overflow: initial !important;
      overflow: visible !important;
    }
  }
`;

export const RejectCompressorContainer = styled.div`
  display: flex;
  gap: 2rem;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
  }

  .checkbox-container {
    overflow-y: auto;
  }
`;
